










































  import Vue from 'vue';
  import {RequestSession} from "@/interfaces/requestSession";
  import {Donation} from "@/interfaces/donation/donation";
  import InvoiceDocumentComponent from "@/components/invoice/InvoiceDocumentComponent.vue";
  import {Type as PaymentType} from "@/interfaces/economy/paymentMethod";
  import {isInvoice} from "@/classes/PaymentMethod";

  export default Vue.extend({
    name: 'InvoiceView',
    components: { InvoiceDocumentComponent },
    data() {
      return {
      };
    },
    computed: {
      requestSession(): RequestSession {
        return this.$store.state.requestSession
      },
      donation(): Donation {
        return this.$store.state.donation
      },
      currentStep() {
        return this.$store.state.currentStep
      },
      getActionText() {
        return this.$t('invoice.actionText', { invoiceDeliveryAction: this.donation.paymentSpecification.paymentMethod.type === PaymentType.INVOICE_EMAIL
                                                                      ? this.$t('invoice.invoiceSentToEmail', { email: this.donation.donor.invoiceEmail })
                                                                      : this.donation.paymentSpecification.paymentMethod.type === PaymentType.INVOICE_PRINT
                                                                        ? this.$t('invoice.invoiceReadyForPrint')
                                                                        : this.$t('invoice.invoiceWillBeMailed') });
      },
      invoiceIsImage(): boolean {
        return this.donation.paymentSpecification.paymentMethod.type === PaymentType.INVOICE_EMAIL || this.donation.paymentSpecification.paymentMethod.type === PaymentType.INVOICE_POST;
      },
      sendIcon() {
        return this.donation.paymentSpecification.paymentMethod.icon;
      },
      isInvoice(): boolean {
        return this.donation.paymentSpecification != null && isInvoice(this.donation.paymentSpecification.paymentMethod.type);
      },
      createdInvoice() {
        return this.$store.state.invoice;
      }
    },
    watch: {
    },
    mounted() {
    },
    methods: {
      reset() {
        this.$emit('reset');
      },
    },
  });
